import { RootAppState } from 'store/configureStore'

export const activityClipboardSelector = (state: RootAppState) =>
  state.materials.activitiesClipboard
